import React, { useState } from 'react';
import { MessageCirclePlus } from 'lucide-react';
import { Dialog, DialogContent } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import AIAssistantForm from './AIAssistantForm';
import { GlobalDialogProps } from '../../../types';

interface AIAssistantDialogProps extends GlobalDialogProps {
  formSource?: string;
}

const AIAssistantDialog: React.FC<AIAssistantDialogProps> = ({
  onClose,
  formSource = 'AI Assistant Dialog',
}) => {
  const [showBackButton, setShowBackButton] = useState(false);
  const [resetChat, setResetChat] = useState(0);

  const handleBackToOptions = () => {
    setShowBackButton(false);
    setResetChat((prev) => prev + 1); // Trigger reset in child
  };

  const handleShowBackButton = (show: boolean) => {
    setShowBackButton(show);
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-4xl w-full h-[80vh] flex flex-col p-0">
        <div className="flex items-center justify-between px-6 py-2 border-b shrink-0 min-h-[48px]">
          <h2 className="text-base font-semibold">Get Support</h2>
          <div className="flex items-center gap-2 mr-6 h-8">
            {showBackButton ? (
              <Button
                variant="ghost"
                size="icon"
                onClick={handleBackToOptions}
                className="h-8 w-8"
                title="New conversation"
              >
                <MessageCirclePlus className="h-4 w-4" />
              </Button>
            ) : (
              <div className="h-8 w-8" />
            )}
          </div>
        </div>
        <div className="flex-1 min-h-0">
          <AIAssistantForm
            formSource={formSource}
            onClose={onClose}
            onShowBackButton={handleShowBackButton}
            resetTrigger={resetChat}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AIAssistantDialog;
